import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "无解的知识库", -1)
const _hoisted_2 = { class: "login-menu" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "login-menu" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "登录", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("关于我们")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("用户管理")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("电子书管理")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("分类管理")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!

  return (_openBlock(), _createBlock(_component_a_layout_header, { class: "header" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_popconfirm, {
        title: "确认退出吗?",
        "ok-text": "是",
        "cancel-text": "否",
        onConfirm: _ctx.logout
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("a", _hoisted_2, _hoisted_4, 512), [
            [_vShow, _ctx.user.id]
          ])
        ]),
        _: 1
      }, 8, ["onConfirm"]),
      _withDirectives(_createElementVNode("a", _hoisted_5, [
        _createElementVNode("span", null, "您好: " + _toDisplayString(_ctx.user.name), 1)
      ], 512), [
        [_vShow, _ctx.user.id]
      ]),
      _withDirectives(_createElementVNode("a", {
        class: "login-menu",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showLoginModal && _ctx.showLoginModal(...args)))
      }, _hoisted_7, 512), [
        [_vShow, !_ctx.user.id]
      ]),
      _createVNode(_component_a_menu, {
        theme: "dark",
        mode: "horizontal",
        style: { lineHeight: '64px' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu_item, { key: "/" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, { key: "/about" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/about" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_menu_item, {
            key: "/admin/user",
            style: _normalizeStyle(_ctx.user.id ? null : {display: 'none'})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/admin/user" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_a_menu_item, {
            key: "/admin/ebook",
            style: _normalizeStyle(_ctx.user.id ? null : {display: 'none'})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/admin/ebook" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_a_menu_item, {
            key: "/admin/category",
            style: _normalizeStyle(_ctx.user.id ? null : {display: 'none'})
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/admin/category" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_modal, {
        title: "登录",
        visible: _ctx.loginModalVisible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginModalVisible) = $event)),
        "confirm-loading": _ctx.loginModalLoading,
        onOk: _ctx.login
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: _ctx.loginUser,
            "label-col": {span: 6},
            "wrapper-col": {span: 18}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "登录名" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.loginUser.loginName,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginUser.loginName) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "密码" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.loginUser.password,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginUser.password) = $event)),
                    type: "password"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["visible", "confirm-loading", "onOk"])
    ]),
    _: 1
  }))
}